import {
  Apple,
  CalendarDays,
  Dumbbell,
  FileText,
  Home,
  QrCode,
  ShieldCheck,
  Star,
  Trophy,
  UserRound,
  Wallet,
  type LucideIcon,
} from "lucide-react";

export interface MemberNavItem {
  to: string;
  end?: boolean;
  icon: LucideIcon;
  /** i18n key + English fallback. */
  labelKey: string;
  fallback: string;
}

export interface MemberNavGroup {
  key: string;
  labelKey: string;
  fallback: string;
  items: MemberNavItem[];
}

export const NAV = {
  home: { to: "/member", end: true, icon: Home, labelKey: "memberUi.nav.home", fallback: "Home" },
  classes: { to: "/member/classes", icon: CalendarDays, labelKey: "memberUi.nav.classes", fallback: "Classes" },
  workout: { to: "/member/workout", icon: Dumbbell, labelKey: "memberUi.nav.workout", fallback: "Workout" },
  nutrition: { to: "/member/nutrition", icon: Apple, labelKey: "memberUi.nav.nutrition", fallback: "Nutrition" },
  pt: { to: "/member/pt", icon: UserRound, labelKey: "memberUi.nav.pt", fallback: "Personal training" },
  qr: { to: "/member/access-qr", icon: QrCode, labelKey: "memberUi.nav.accessQr", fallback: "Door access" },
  wallet: { to: "/member/wallet", icon: Wallet, labelKey: "memberUi.nav.wallet", fallback: "Wallet" },
  achievements: { to: "/member/achievements", icon: Trophy, labelKey: "memberUi.nav.achievements", fallback: "Achievements" },
  documents: { to: "/member/documents", icon: FileText, labelKey: "memberUi.nav.documents", fallback: "Documents" },
  account: { to: "/member/account", icon: ShieldCheck, labelKey: "memberUi.nav.account", fallback: "Account & privacy" },
  consent: { to: "/member/consent", icon: Star, labelKey: "memberUi.nav.consent", fallback: "Consents" },
} satisfies Record<string, MemberNavItem>;

/** Desktop sidebar + mobile menu sheet grouping. */
export const NAV_GROUPS: MemberNavGroup[] = [
  { key: "train", labelKey: "memberUi.group.train", fallback: "Train", items: [NAV.home, NAV.classes, NAV.workout, NAV.nutrition, NAV.pt] },
  { key: "membership", labelKey: "memberUi.group.membership", fallback: "Membership", items: [NAV.qr, NAV.wallet, NAV.achievements] },
  { key: "account", labelKey: "memberUi.group.account", fallback: "Account", items: [NAV.documents, NAV.account, NAV.consent] },
];

/** Mobile bottom bar: 2 + raised centre action + 1 + Menu. */
export const BOTTOM_LEFT: MemberNavItem[] = [NAV.home, NAV.classes];
export const BOTTOM_CENTER: MemberNavItem = NAV.qr;
export const BOTTOM_RIGHT: MemberNavItem[] = [NAV.workout];
